import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form.name, form.email, form.password, form.phone);
      toast.success("Welcome to konokangen.");
      navigate("/");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Sign up failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-[72vh] grid lg:grid-cols-2">
      <div className="flex items-center justify-center p-10 order-2 lg:order-1">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="register-form">
          <div className="overline">Create account</div>
          <h1 className="font-serif text-5xl mt-3 mb-10">Begin your collection.</h1>
          {[
            ["name", "Name", "text"],
            ["email", "Email", "email"],
            ["phone", "WhatsApp number (with country code, optional)", "tel"],
            ["password", "Password", "password"],
          ].map(([k, label, type]) => (
            <div key={k} className="mb-5">
              <label className="text-xs uppercase tracking-[0.16em] text-[#5c5a56]">{label}</label>
              <input
                type={type}
                value={form[k]}
                onChange={(e) => setForm({ ...form, [k]: e.target.value })}
                placeholder={k === "phone" ? "+91 98xxxxxxxx" : undefined}
                className="w-full mt-1 border-b border-[#ebe5df] py-3 bg-transparent focus:outline-none focus:border-[#c58b76]"
                required={k !== "phone"}
                data-testid={`register-${k}`}
              />
            </div>
          ))}
          <button
            type="submit"
            disabled={loading}
            className="btn-primary w-full justify-center mt-4 disabled:opacity-60"
            data-testid="register-submit"
          >
            {loading ? "Creating…" : "Create account"}
          </button>
          <p className="text-sm text-[#5c5a56] mt-6">
            Already a member?{" "}
            <Link to="/login" className="u-link text-[#1a1918]">Sign in</Link>
          </p>
        </form>
      </div>
      <div
        className="hidden lg:block bg-cover bg-center order-1 lg:order-2"
        style={{
          backgroundImage:
            "url(https://static.prod-images.emergentagent.com/jobs/ee5196d8-7ba8-419d-a53c-e1c97e62948a/images/d219db57c3715855c12925ad17efd3b40842201fdc5c6c136b43f8f941093781.png)",
        }}
      ></div>
    </main>
  );
}
